var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JsonObject, JsonProperty } from "json2typescript";
import { Constants } from "../../Constants";
import { DateTimeStampConverter } from "../../custom-converters/date-time-stamp-converter";
/**
 * @category Model V2
 */
var UpdateResourceMetadataResponse = /** @class */ (function () {
    function UpdateResourceMetadataResponse() {
        this.resourceIri = "";
        this.resourceClassIri = "";
        this.label = "";
        this.lastModificationDate = "";
        this.hasPermissions = "";
    }
    __decorate([
        JsonProperty(Constants.ResourceIri, String),
        __metadata("design:type", String)
    ], UpdateResourceMetadataResponse.prototype, "resourceIri", void 0);
    __decorate([
        JsonProperty(Constants.ResourceClassIri, String),
        __metadata("design:type", String)
    ], UpdateResourceMetadataResponse.prototype, "resourceClassIri", void 0);
    __decorate([
        JsonProperty(Constants.Label, String, true),
        __metadata("design:type", String)
    ], UpdateResourceMetadataResponse.prototype, "label", void 0);
    __decorate([
        JsonProperty(Constants.LastModificationDate, DateTimeStampConverter, true),
        __metadata("design:type", String)
    ], UpdateResourceMetadataResponse.prototype, "lastModificationDate", void 0);
    __decorate([
        JsonProperty(Constants.HasPermissions, String, true),
        __metadata("design:type", String)
    ], UpdateResourceMetadataResponse.prototype, "hasPermissions", void 0);
    UpdateResourceMetadataResponse = __decorate([
        JsonObject("UpdateResourceMetadataResponse")
    ], UpdateResourceMetadataResponse);
    return UpdateResourceMetadataResponse;
}());
export { UpdateResourceMetadataResponse };
